// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\pages\\locations\\index.ts"
);
import.meta.hot.lastModified = "1757171103344.3704";
}
// REMIX HMR END

export { WelcomeSection } from "./WelcomeSection";
export { LocationInfo } from "./LocationInfo";
export { StudiosSection } from "./StudiosSection";
export { EventsSection } from "./EventsSection";
export { PlanYourVisitSection } from "./PlanYourVisitSection";
